export default __webpack_public_path__ + "static/driveway-clearing-8402e28739af35e97ffea0d9517bce9b.webp";